<template>
  <div id="atmospheric_precipitation_ship">
    <div 
      v-if="receivedData"
    >
      <TabsCustomGraphic 
        :received-data="receivedData"
        id="atmospheric_precipitation"
      />
    </div>  
  </div>
</template>
<script>

import CMS from '@/model/cms'
import Service from '@/service/service.js'
import { mapGetters } from 'vuex'

export default {
  name: 'AtmosphericPrecipitation',
  components: {
    TabsCustomGraphic: () => import('@/components/graph/TabsCustomGraphic.vue'),
  },

  computed: {
    ...mapGetters({
      userToken: 'getUserToken'
    }),
  },

  data () {
    return {
      receivedData: null,
      blockId: 'atmospheric_precipitation',
      cloneElementId: 'atmospheric_precipitation_ship'
    }
  },

  mounted() {
    this.getGraphData()
    Service.elementClone(this.blockId, this.cloneElementId)
  },

  methods: {
    getGraphData() {
      CMS.getGraph(this.userToken, '24,25,26,27,28,29').then((response) => {
        this.receivedData = response.data
      })
    }
  }
}
</script>